<template>
  <v-card>
    <div v-if="title">
      <v-card-title class="font-weight-bold">{{ title }}</v-card-title>
    </div>

    <v-card-text>
      <slot />
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "Card",
  props: {
    title: String
  }
};
</script>

<style lang="scss">
/* Gives all cards have bottom margin */
.v-card {
  margin: 0 auto 1rem !important;
  padding: 0.75rem inherit;
  p,
  ul,
  ol {
    padding: 0.5rem 1rem !important;
  }
  ol,
  ul {
    margin-left: 1.75rem;
  }
  p {
    margin-bottom: 0 !important;
  }
  &.v-sheet {
    border-radius: 4px !important;
  }
}

/* Ensures words on card titles are not broken */
.v-card__title {
  word-break: break-word !important;
}

/* Ensures all card content is 100% width and doesn't inherantly have padding */
.v-card__text {
  padding: 0 !important;
  width: 100% !important;
}

//
@media only screen and (min-width: 1024px) {
  .v-card {
    // margin: auto !important;
    width: 1000px !important;
  }
}
</style>
